// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__card {
  border-radius: 10px;
  height: 100%;
  width: 100%;
  box-shadow: none;
  border: 1px solid rgb(214, 214, 214);
  display: flex;
  flex-direction: column;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__containerWidgetCard {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__cardHeader {
  color: white;
  background-color: var(--colors-yuzu-greyLight);
  padding: 5px 12px !important;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__containerWidgetCardHeader {
  background-color: var(--colors-yuzu-greyLight);
  color: white;
  padding: 5px 10px !important;
  cursor: move;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__containerWidgetCardHeader .app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__titleContainer {
    display: flex;
    align-items: center;
  }

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__cardHeader:hover {
  cursor: move;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__cardContentContainer {
  overflow: auto;
  scrollbar-width: unset;
  height: 100%;
  width: 100%;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__cardContent {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__cardContentContainer::-webkit-scrollbar {
  width: 5px;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__action {
  margin: 0;
  align-self: initial !important;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__blur {
  filter: blur(3px);
  transition: filter 0.3s ease-in;
  pointer-events: none;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__iconBtn {
  color: white !important;
  font-size: 17px !important;
  margin-right: 5px !important;
  margin-top: 3px !important;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__error {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/ProductionManagement/Dashboards/Widgets/WidgetContainer/styles.scss"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAIA;EACE,YAAY;EACZ,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,4BAA4B;EAC5B,YAAY;AAMd;;AAJE;IACE,aAAa;IACb,mBAAmB;EACrB;;AAKF;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".card {\n  border-radius: 10px;\n  height: 100%;\n  width: 100%;\n  box-shadow: none;\n  border: 1px solid rgb(214, 214, 214);\n  display: flex;\n  flex-direction: column;\n}\n\n.containerWidgetCard {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n// ---------------------------\n\n.cardHeader {\n  color: white;\n  background-color: var(--colors-yuzu-greyLight);\n  padding: 5px 12px !important;\n}\n\n.containerWidgetCardHeader {\n  background-color: var(--colors-yuzu-greyLight);\n  color: white;\n  padding: 5px 10px !important;\n  cursor: move;\n\n  & .titleContainer {\n    display: flex;\n    align-items: center;\n  }\n}\n\n// --------------------------\n\n.cardHeader:hover {\n  cursor: move;\n}\n\n.cardContentContainer {\n  overflow: auto;\n  scrollbar-width: unset;\n  height: 100%;\n  width: 100%;\n}\n\n.cardContent {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n}\n\n.cardContentContainer::-webkit-scrollbar {\n  width: 5px;\n}\n\n.action {\n  margin: 0;\n  align-self: initial !important;\n}\n\n.blur {\n  filter: blur(3px);\n  transition: filter 0.3s ease-in;\n  pointer-events: none;\n}\n\n.iconBtn {\n  color: white !important;\n  font-size: 17px !important;\n  margin-right: 5px !important;\n  margin-top: 3px !important;\n}\n\n.error {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n// :global(.react-grid-item.react-grid-placeholder) {\n//   background: rgba(255, 193, 193, 0.5);\n//   z-index: -1;\n// }\n\n// :global(.react-resizable-handle) {\n//   bottom: 2px;\n//   right: 2px;\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__card`,
	"containerWidgetCard": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__containerWidgetCard`,
	"cardHeader": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__cardHeader`,
	"containerWidgetCardHeader": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__containerWidgetCardHeader`,
	"titleContainer": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__titleContainer`,
	"cardContentContainer": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__cardContentContainer`,
	"cardContent": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__cardContent`,
	"action": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__action`,
	"blur": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__blur`,
	"iconBtn": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__iconBtn`,
	"error": `app-pages-Project-ProductionManagement-Dashboards-Widgets-WidgetContainer-___styles__error`
};
export default ___CSS_LOADER_EXPORT___;
